import React from "react";
import { lazyWithRetry } from "utils/lazy-with-retry";

const LazySchemaEditor = lazyWithRetry(() => import("./SchemaEditor"));

const SchemaEditor = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazySchemaEditor {...props} />;

export default SchemaEditor;
